// extracted by mini-css-extract-plugin
module.exports = {"layout":"bC_N","content":"bC_s","title":"bC_f","subtitle":"bC_R","apps":"bC_df","link":"bC_cn"};